import { JustRightHeightModal } from 'components/styled/scoped';
import { Input, message, ModalProps, Radio, Space } from 'antd';
import { useTranslate } from '@tolgee/react';
import { cx, css } from '@emotion/css';
import { useResultTypeLabel } from '../hooks/useLabel';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { batchCloseTodo } from '../service';
import { map } from 'lodash-es';

export interface BatchCloseWithResultSelfProps {
  records: Todo.Record[];
}
interface BatchCloseWithResultProps extends ModalProps, BatchCloseWithResultSelfProps {
  results: string[];
}
export const BatchCloseWithResult = (props: BatchCloseWithResultProps) => {
  const { t } = useTranslate();
  const { records, results, className, visible, onCancel, ...restProps } = props;
  const { getResultTypeLabel } = useResultTypeLabel();
  const [result, setResult] = useState<string>();
  const [customResult, setCustomResult] = useState('');
  const { isLoading, mutateAsync } = useMutation({
    mutationFn: (...data: Parameters<typeof batchCloseTodo>) => {
      return batchCloseTodo(...data);
    },
    onError: () => {
      message.error(t('translation.操作失败，请稍后再试'));
    },
    onSuccess: () => {
      message.success(t('feedback.已关闭'));
      onCancel?.(null!);
    },
  });

  return (
    <JustRightHeightModal
      title={t('ViewShops.批量关闭')}
      width={476}
      visible={visible}
      onCancel={onCancel}
      okText={t('ViewDashboard.确认')}
      onOk={() => {
        mutateAsync({
          ids: map(records, (e) => e.id),
          ...(result === 'OTHER'
            ? {
                customOperateResult: customResult,
              }
            : {
                resultType: result,
              }),
        });
      }}
      okButtonProps={{
        loading: isLoading,
        disabled: !result || (result === 'OTHER' && !customResult),
      }}
      className={cx(
        css`
          .ant-modal-body {
            padding: 16px;
            margin: 0;
          }
        `,
        className,
      )}
      {...restProps}
    >
      <div className="mb-[16px]">{t('choose_solution')}:</div>
      <Radio.Group
        value={result}
        onChange={(e) => {
          setResult(e.target.value);
        }}
      >
        <Space direction="vertical">
          {results?.map((each) => {
            return (
              <Radio value={each} key={each}>
                {getResultTypeLabel(each)}
              </Radio>
            );
          })}
          <Radio key="OTHER" value="OTHER">
            {t('resultFallback.OTHER')}
          </Radio>
        </Space>
      </Radio.Group>
      {result === 'OTHER' && (
        <div className="pl-[23px] mt-[11px]">
          <Input
            value={customResult}
            onChange={({ target: { value } }) => setCustomResult(value)}
            placeholder={t('trade.请输入')}
          />
        </div>
      )}
    </JustRightHeightModal>
  );
};

BatchCloseWithResult.displayName = 'BatchCloseWithResult';
